import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";
import { YES, NO, NO_DEGREE } from "pages/SurveyForm/constants/uiControls";

type Props = {
  formik: any;
  sectionId: number;
};

const Step14: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const clearStudyInfo = (value: string) => {
    if (value === NO) {
      formik.setFieldValue("careerName", { ...formik.values.careerName, value: "" });
      formik.setFieldValue("careerModality", { ...formik.values.careerModality, value: "" });
      formik.setFieldValue("studyDays", { ...formik.values.studyDays, value: "" });
      formik.setFieldValue("studySchedule", { ...formik.values.studySchedule, value: "" });
    }
  };

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      visible: true,
      name: "educationLevel",
      questionData: questions[0],
      elementType: ElementType.Select,
      label: "Último nivel educativo aprobado",
    },
    {
      key: 1,
      formik,
      maxLength: 60,
      name: "degreeName",
      elementType: ElementType.Textfield,
      label: "Nombre del título recibido",
      questionData: questions[0]?.subQuestions?.length ? questions[0]?.subQuestions[0] : {},
      visible: formik?.values?.educationLevel?.value !== NO_DEGREE,
    },
    {
      key: 2,
      formik,
      visible: true,
      name: "isStudying",
      questionData: questions[1],
      elementType: ElementType.Radio,
      label: "¿Está actualmente estudiando?",
      onChangeCallback: clearStudyInfo,
    },
    {
      key: 3,
      formik,
      maxLength: 100,
      name: "careerName",
      elementType: ElementType.Textfield,
      questionData: questions[1]?.subQuestions?.length ? questions[1]?.subQuestions[0] : {},
      label: "¿Qué estudia actualmente el colaborador?",
      visible: formik?.values?.isStudying?.value === YES,
    },
    {
      key: 4,
      formik,
      name: "careerModality",
      questionData: questions[2],
      label: "Modalidad de estudio",
      elementType: ElementType.Select,
      visible: formik?.values?.isStudying?.value === YES,
    },
    {
      key: 5,
      formik,
      name: "studyDays",
      label: "Días de estudio",
      questionData: questions[3],
      elementType: ElementType.Select,
      visible: formik?.values?.isStudying?.value === YES,
    },
    {
      key: 6,
      formik,
      name: "studySchedule",
      questionData: questions[4],
      label: "Horario de estudio",
      elementType: ElementType.Select,
      visible: formik?.values?.isStudying?.value === YES,
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='left'>
        Cuéntenos más de usted: formación actual
      </Typography>
      <StepContent>{dataModel?.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step14;
